export default "__VITE_ASSET__Cp4$DFRB__"